import { Modal } from "antd";
import { FC } from "react";
import { CloseSvg } from "utils/svgs";
import styles from "./index.module.scss";
import { ConfirmLoginOverrideProps } from "./types";
import { WarningOutlined } from "@ant-design/icons";

// ConfirmLoginOverride popup
const ConfirmLoginOverride: FC<ConfirmLoginOverrideProps> = (props) => {
  // Inits
  const { handleCancel, handleOk, isModalOpen, proceedHandler, isLoading } =
    props;

  //   JSX
  return (
    <Modal
      title={
        <div className={styles["confirm-delete-model"]}>
          <WarningOutlined className={styles["warning-icon"]} />

          <h4 className={styles["confirm-delete-model__title"]}>
            You are currently logged in from another location. If you wish to
            continue and log out the other session, click Proceed.Otherwise, you
            can choose to Log Out the session from the other location.
          </h4>
        </div>
      }
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      centered={true}
      width={700}
      closeIcon={<CloseSvg />}
      footer={[
        <div key={"wrapper"} className={styles["confirm-delete-model__button"]}>
          <button
            key="ok"
            className={`${styles["confirm-delete-model__button--save"]} ${
              styles["confirm-delete-model__button--btn"]
            } ${isLoading && "pointer-event-none"}`}
            onClick={proceedHandler}
          >
            {isLoading ? (
              <img
                src={`${process.env.REACT_APP_IMAGES_BASE_URL}/assets/gifs/loading-black.gif`}
                crossOrigin={
                  process.env.REACT_APP_ENV === "local"
                    ? undefined
                    : "anonymous"
                }
                height={40}
              />
            ) : (
              "Proceed"
            )}
          </button>
          <button
            key="cancel"
            onClick={handleCancel}
            className={`${styles["confirm-delete-model__button--cancel"]} ${styles["confirm-delete-model__button--btn"]}`}
          >
            Cancel
          </button>
        </div>,
      ]}
    ></Modal>
  );
};

export default ConfirmLoginOverride;
